import React, {useState, useEffect} from 'react'
import { Box, Typography, Button, Stack, Skeleton, Grid  } from "@mui/material";
import Correct from '../../img/products/Correct.png';
import '../../index.css';
import { useNavigate } from 'react-router-dom';
import { ApiService } from '../../API/AxiosInstance';
import InfiniteIcon from '../../img/products/infinite.png';
import { ShimmerSkeleton } from '../../utils/SkimmerSkeleton';
import { captureException } from '@sentry/react';
import { colors } from '../../Theme/tokens';
import PrimaryButton from '../../Theme/styled/PrimaryButton';
import { ReactComponent as ProjectIcon } from '../../img/products/projectIcon.svg';
import { ReactComponent as MaturityIcon } from '../../img/products/maturityIcon.svg';
import { ReactComponent as AprYieldIcon } from '../../img/products/aprYieldIcon.svg';
import IdleCashField from '../../components/IdleCashField';

export const changeRiskTypeName = (riskRating) => {
  if(riskRating) {
    const riskType = {Low: "Conservative", Medium: "Balanced", High: "Aggressive"}
    console.log("riskRating ",riskType[riskRating])
    return riskType[riskRating]
  }
    return ''
}

export default function UpcomingEventsData() {
    const [allProducts, setAllProducts] = useState([])
    const [products,setProducts] = useState([])
    const navigate = useNavigate()
    const [transactionProducts, setTransactionProducts] = useState([])
    const userId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).sub_id : ''
    const [loading, setLoading] = useState(false)
    const [idleCash,setIdleCash] = useState(0.00)
  
    useEffect(() => {
      if(userId)  getIdleCash()
    },[userId])

    const getIdleCash =async () => {
      try {
        const response = await ApiService().get(`users/${userId}/idle-cash`)
        console.log("idlecash ",response)
        setIdleCash(response?.data?.idleCashPortfolio?.amount)
      } catch(error) {
        console.log("error ",error)
      }
    }
        
    const getSubscribedProducts = async() => {
        try {
          const response =  await ApiService().get(`portfolios?userId=${userId}&limit=100`)
          if(response?.data?.portfolios?.length > 0) {
            setTransactionProducts(response.data.portfolios)
          }
        } catch(error) {
        setLoading(false)
        captureException(error)
        }
      }

    useEffect(() => {
        (async () => {
            setLoading(true)
            await ApiService().get(`products?page=0&limit=25`).then(res => {
                if(res?.data?.products?.length > 0) {
                    setAllProducts(res?.data?.products?.filter(item => item.isActive))
                }
            })
                .catch(error => {
                    setLoading(false)
                    captureException(error)
                })
        })()
        getSubscribedProducts()

    }, [])

    useEffect(() => {
        if (allProducts?.length > 0) {
            const resultArray = allProducts.map(firstObj => {
                if (transactionProducts?.length == 0) {
                  return {
                    ...firstObj,
                    subscribed: false
                  };
                }
                const isSubscribed = transactionProducts.some(secondObj => secondObj.productId === firstObj.id);
                return {
                  ...firstObj,
                  subscribed: isSubscribed
                };
              });
              console.log("resultArray ",allProducts,transactionProducts)
            setProducts(resultArray)
            setLoading(false)
        }
    }, [allProducts, transactionProducts]);

  const getTagIconUrl = (tags) => {
    const tag = tags?.find(tag => tag.iconUrl);
    return tag?.iconUrl ? tag?.iconUrl : "https://assets.tradetogether.app/products/BitcoinAdvantage.svg";
  };
      
    // const getRiskRatingWithLabel = (tags) => {
    //     const tag = tags?.find(tag => tag.metrics && tag.metrics[0]?.riskRating);
    //     const returnedLabel = changeRiskTypeName(tag?.metrics[0]?.riskRating)
    //     return returnedLabel || '';
    // };

    const getRiskRating = (tags, riskType) => {
      const tag = tags?.find(tag => tag.metrics && tag.metrics[0]?.riskRating);
      if(riskType) {
        const returnedLabel = changeRiskTypeName(tag?.metrics[0]?.riskRating)
        return returnedLabel || '';
      } else {
        return tag?.metrics[0]?.riskRating || '';
      }
    };
    
    const getProjectedReturns = (tags) => {
        const tag = tags?.find(tag => tag.metrics && tag.metrics[1]?.projectedReturns);
        return tag?.metrics[1]?.projectedReturns || '';
    };



    return (
     
         <>
         <Box sx={{display:"flex",justifyContent:"space-between", alignItems:"center", flexDirection:{xs: "column", md:"row"}, mb:2}}>
            <Box sx={{display:"flex", flexDirection:"column", gap:"10px", alignItems:{xs:"center", sm:"flex-start"}, justifyContent:{xs:"center", lg:"flex-start"}, mb:2}}>
              <Typography sx={{ fontWeight: '550', color:colors.text.primary, fontSize:{xs:"21px", sm:"23.99px"}, lineHeight:"29.03px" }}>
                Product Listings
              </Typography>
              <Typography sx={{ fontWeight: '400',  color:colors.text.secondary, fontSize:'12px', lineHeight:"17px", letterSpacing:"5%", textAlign:{xs:"center", sm:"left"}}}>
              Browse our selection of financial products designed to meet diverse investment goals. Choose the one that best suits your Risk tolerance profile.
              </Typography>
            </Box>     
           <IdleCashField idleCash={idleCash} />
         </Box>
         
     {!loading ? 
<Box
  sx={{
    display: 'grid',
    gridTemplateColumns: {
      xs: 'repeat(auto-fit, minmax(280px, 1fr))',
      sm: 'repeat(auto-fit, minmax(340px, 1fr))',
      md: 'repeat(auto-fit, minmax(320px, 1fr))',
      lg: 'repeat(auto-fit, minmax(300px, 1fr))',
      xl: 'repeat(auto-fit, minmax(320px, 1fr))',
    },
    justifyItems: 'stretch',
    gap: { xs: '20px', sm: '24px', md: '24px', lg: '28px', xl: '32px' },
  }}
>
  {products?.map((item) => (
    <Box
      key={item.id}
      sx={{
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: '14px',
        backgroundColor: colors.background.paper,
        borderRadius: '21px',
        padding: { xs: '14px', md: '20px' },
        boxShadow: `0px 1px 5px 0px ${colors.border.card}`,
      }}
    >

                  {/* Icon + Title row */}
                  <Box sx={{ display: 'flex', gap: '14px', alignItems: 'center' }}>
                    <Box
                      sx={{
                        width: { xs: '52px', md: '60px' },
                        height: { xs: '52px', md: '60px' },
                        borderRadius: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      <Box component="img" src={getTagIconUrl(item?.tags)} sx={{ width: '32px', height: '32px', scale:2, objectFit: 'contain' }} />
                    </Box>
                    <Typography variant="h4" color="primary" sx={{ fontWeight: '600 !important',  color: colors.primary.main, fontSize: '16px', lineHeight: '1.3' }}>
                      {item?.name}
                    </Typography>
                  </Box>

                  {/* Stats row - single bordered container with inline dividers */}
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'stretch',
                      gap: '8px',
                      padding: getProjectedReturns(item?.tags) ? "0 5px" : '0px'
                    }}
                  >
                    {getProjectedReturns(item?.tags) && (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '6px',
                          flex: 1,
                          width: { xs: '96px', md: '96px' },
                          height: { xs: '63px', md: '63px' },
                          boxSizing: 'border-box',
                          border: `1px solid ${colors.border.card}`,
                          borderRadius: '8px',
                        }}
                      >
                        <Box sx={{ display: "flex", flexDirection: "column",gap:"1px", alignItems:"center" }}>
                          <Box sx={{display:"flex",justifyContent:"center"}}><ProjectIcon /></Box>
                          <Typography sx={{ fontSize: '11px', fontWeight: '500', color: colors.neutral.outlinedText, textAlign:"center" }}>
                            {(item?.id == 6 || item?.id == 8) ? '' : 'Project'}
                          </Typography>                                
                          {(item?.id == 6 || item?.id == 8) ? (
                            // <Typography sx={{ fontSize: '11px', fontWeight: '600', color: colors.neutral.outlinedText }}>
                            //   {item?.tenor} Months
                            // </Typography>
                            ""
                          ) : (

                              <Typography sx={{ fontSize: '11px', fontWeight: '600', color: colors.neutral.info100 }}>
                                {getProjectedReturns(item?.tags)}%
                              </Typography>
                          )}
                        </Box>
                        
                      </Box>
                    )}

                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        flex: 1,
                        width: { xs: '96px', md: '96px' },
                        height: { xs: '63px', md: '63px' },
                        boxSizing: 'border-box',
                        border: `1px solid ${colors.border.card}`,
                        borderRadius: '8px',
                      }}
                    >
                      <Box sx={{ display: "flex", flexDirection: "column", alignItems:"center",gap:"1px" }}>
                        <Box sx={{ display: "flex", justifyContent: "center" }}><MaturityIcon /></Box>
                        <Typography sx={{ fontSize: '11px', fontWeight: '500', color: colors.neutral.outlinedText, textAlign: "center" }}>
                          Maturity
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: '11px',
                            fontWeight: 600,
                            color: colors.neutral.success100,
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {item?.tenor > 100000 ? (
                            <Typography
                              component="span"
                              sx={{
                                fontSize: '18px', // Increase as needed
                                fontWeight: 700,
                                lineHeight: 1,
                              }}
                            >
                              ∞
                            </Typography>
                          ) : (
                            `${item?.tenor} Months`
                          )}
                        </Typography>
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        flex: 1,
                        width: { xs: '96px', md: '96px' },
                        height: { xs: '63px', md: '63px' },
                        boxSizing: 'border-box',
                        border: `1px solid ${colors.border.card}`,
                        borderRadius: '8px',
                      }}
                    >
                      <Box sx={{ display: "flex", flexDirection: "column",alignItems:"center", gap:"1px" }}>
                        <Box sx={{ display: "flex", justifyContent: "center" }}><AprYieldIcon /></Box>
                        <Typography sx={{ fontSize: '11px', fontWeight: '500', color: colors.neutral.outlinedText }}>
                          APR Yield
                        </Typography>

                          <Typography sx={{ fontSize: '11px', fontWeight: '600', color: colors.neutral.orange100 }}>
                            {item?.expectedYield}%
                          </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* Description - bordered box */}
                  <Box
                    sx={{
                      // border: `1px solid ${colors.border.card}`,
                      borderRadius: '10px',
                      padding: '12px 14px',
                      backgroundColor:colors.legacy.Bg_color,
                      width:"100%"
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: '13px',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 4,
                        display: '-webkit-box',
                        overflow: 'hidden',
                        color: colors.text.gray,
                        letterSpacing:"0.5px",
                      }}
                    >
                      {item?.description}
                    </Typography>
                  </Box>

                   {!item?.subscribed && (
              <Box >
                <PrimaryButton onClick={() => navigate(`productDetails/${item.id}`)} sx={{ mt: '4px', width: '100%', height:"46px", borderRadius:"3.26px", maxWidth:"100%" }}>
                  Subscribe
                </PrimaryButton>
              </Box>
            )}
            {item?.subscribed && (
              <Button variant='outlined' onClick={() => navigate(`productDetails/${item.id}`)} sx={{ mt: '4px', width: '100%', height:"46px", borderRadius:"3.26px", maxWidth:"100%", border:`1px solid ${colors.primary.main}`, fontWeight:'550'  }}>
                 More Info
              </Button>
            )}

                </Box>
        ))}
      </Box>
       : 
        <Box sx={{width:"100%", display:"flex", gap:2, flexWrap:"wrap", justifyContent:"space-between"}} >
          {[1,2,3,4,5,6,7,8,9].map(() => (
            <ShimmerSkeleton variant="rectangular" sx={{width:"25%", height:{xs:"100px", md:"120px"} }} />
          ))}
          </Box>
      }
    </>
    )
}
